// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDwKwoenmQYktMXVSkhH-rJin2BZt5NYQ0",
  authDomain: "cvszn-27e9d.firebaseapp.com",
  projectId: "cvszn-27e9d",
  storageBucket: "cvszn-27e9d.appspot.com",
  messagingSenderId: "769393319766",
  appId: "1:769393319766:web:5dd006e8937603cdf480f7",
  measurementId: "G-BNJ6PD6X6L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
